/**
 * What the portal says once it has taken an address for an emailed link.
 * It never says whether the address has an account. A signup link is not
 * sent to one that does, so the signup page says so, and where to go
 * instead: somebody following the website's plan link while signed out
 * lands on signup whether or not they have an account (review A-15).
 */
export function sentNotice(mode: 'signup' | 'reset', email: string): string {
  const sent = `If ${email} is eligible, we’ll send a link to continue. The link is valid for 30 minutes.`;
  return mode === 'signup' ? `${sent} No link is sent to an address that already has an account: sign in instead.` : sent;
}
